import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=46b67de0&scoped=true&"
import script from "./Mail.vue?vue&type=script&lang=js&"
export * from "./Mail.vue?vue&type=script&lang=js&"
import style0 from "./Mail.vue?vue&type=style&index=0&id=46b67de0&prod&lang=scss&scoped=true&"
import style1 from "./Mail.vue?vue&type=style&index=1&id=46b67de0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b67de0",
  null
  
)

export default component.exports